import React, {useState} from "react";
import ArrayStore from "devextreme/data/array_store";
import List from "devextreme-react/list";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import {FilterDelete, Filters, Order} from "../../../../utils/HelpFunctions";
import CommuteIcon from '@material-ui/icons/Commute';
import Dialog from "../../../../palette/Dialog";
import Text from "../../../../palette/Text";
import axios from "axios";
import format from "date-fns/format"
import addYears from 'date-fns/addYears'
import {NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import {inject, observer} from "mobx-react";

const url = 'https://delete-schedules-drivers-easi4xatjq-uc.a.run.app/delete-schedules-drivers'
//const url = 'http://127.0.0.1:5000/delete-schedules-drivers'

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

function RoutesSchedulesList(props) {

    const {data, setDataList, dataHour, setDataHour, DataStore, driverId} = props


    const {companyName, idCompany} = DataStore

    const [dataId, setDataId] = useState(null)
    const [openDialog, setOpenDialog] = useState(false)
    const [load, setLoad] = useState(false)
    const [textButton, setTextButton] = useState('Quitar horario')

    const {enqueueSnackbar} = useSnackbar();
    const dataSource = new ArrayStore({
        key: 'id',
        data: data,
        sort: 'routeName'
    });

    const openDialogPopup = (ID) => {
        setOpenDialog(true)
        setDataId(ID)
    }

    const onDelete = async () => {

        const resultDelete = Filters(data, 'id', dataId)

        const routeName = resultDelete[0].routeName

        const years = []
        const year = format(new Date(), 'yyyy')
        const addYear = addYears(new Date(), 1)
        const nextYear = format(addYear, 'yyyy')

        years.push(year)
        years.push(nextYear)

        const dataSend = {companyName, idCompany, years, routeName, driverId, route: true}

        if(driverId){
            setTextButton('Buscando horarios...')
            setLoad(true)
            await axios.post(url, dataSend, {headers: headers})
                .then(res => {
                    if (res.data.exists) {
                        const resultDelete = FilterDelete(data, 'id', dataId)

                        if (dataHour?.length > 0) {
                            setTextButton('Quitar horario')
                            setLoad(false)
                            const deleteHour = Filters(data, 'id', dataId)
                            const newDataHour = [...dataHour]
                            newDataHour.push(deleteHour[0])
                            const orderHour = Order(newDataHour, 'hour')
                            setDataHour(orderHour)
                        }

                        setDataList(resultDelete)
                        setOpenDialog(false)
                    } else {
                        setLoad(false)
                        setTextButton('Quitar horario')
                        setOpenDialog(false)
                        NotiStackInfo(`Existen reservaciones pendientes en la ruta ${routeName}`, 'error', enqueueSnackbar)
                    }
                }).catch(e=>{console.log(e)})
        }else {
            const resultDelete = FilterDelete(data, 'id', dataId)
            setDataList(resultDelete)
            setOpenDialog(false)
        }
    }


    function ItemTemplate(data) {
        return (
            <div>
                {data !== undefined &&
                <Layout row center space>
                    <LayoutChild row center>
                        <LayoutChild row center>
                            <CommuteIcon style={{color: '#ff8a65'}}/>
                        </LayoutChild>
                        <LayoutChild left={10}>
                            <Text hover={false} color={'#333'} weight={'800'} text={data.routeName} size={14}/>
                            <Text hover={false} color={'gray'} weight={'500'} text={`${data.days} a las ${data.hour}`}
                                  size={11}/>
                        </LayoutChild>
                    </LayoutChild>
                    <i className="far fa-trash-alt" onClick={() => openDialogPopup(data.id)}
                       style={{color: 'red', hint: 'Eliminar'}}/>
                </Layout>}
            </div>
        )
    }

    return (
        <div className="list-container-prz">
            <LayoutChild width="100%" center padding={10}>
                <Text hover={false} text={'Rutas y horarios'} size={15} color="#1A5487" weight={'900'}/>
            </LayoutChild>
            <Dialog title="Eliminar horario" text={'Esta seguro que desea quitar este horario de la lista ?'}
                    onClick={onDelete}
                    openDialog={openDialog} setOpenDialog={setOpenDialog} textButton={textButton} load={load}/>
            <Layout color={'transparent'}>
                <List
                    dataSource={dataSource}
                    height={'auto'}
                    itemRender={ItemTemplate}
                    searchExpr={['origin', 'destination', 'days']}
                    searchEnabled={true}
                    searchMode={'contains'}
                    showSelectionControls={true}
                />
            </Layout>
        </div>
    )
}


export default inject('DataStore')(observer(RoutesSchedulesList));
